import i18n from "@/locales";

export default [
  {
    path: "/login",
    name: "login",
    component: () => import("@/views/login/index.vue"),
    redirect: "/login/login-password",
    children: [
      //密码登录
      {
        path: "login-password",
        name: "login-password",
        component: () => import("@/views/login/LoginPassword.vue"),
        meta: {
          title: '',
          keepAlive: true
        }
      },
      //短信验证码登录
      {
        path: "login-message",
        name: "login-message",
        component: () => import("@/views/login/LoginMessage.vue"),
        meta: {
          title: ''
        }
      }
    ]
  },
  // H5登录
  {
    path: "/login-index",
    name: "loginIndex",
    redirect: "/login-h5",
    component: () => import("@/views/login-h5/Index.vue"),
    meta: {
      title: i18n.t("login.title"),
      keepAlive: true
    },
    children: [
      {
        path: "/login-h5",
        name: "loginH5",
        component: () => import("@/views/login-h5/loginH5.vue"),
        meta: {
          showHeader: true,
          keepAlive: true,
          title: i18n.t("login.title")
        }
      },
      {
        path: "/license-agreement-keep",
        name: "license-agreement-keep",
        component: () => import("@/views/protocols/LicenseAgreement.vue"),
        meta: {
          showHeader: true,
          keepAlive: true,
          title: i18n.t("protocols.license_agreement_nav_title")
        }
      },
      {
        path: "/register-privacy-policy-keep",
        name: "register-privacy-policy-keep",
        component: () => import("@/views/protocols/RegisterPrivacyPolicy.vue"),
        meta: {
          showHeader: true,
          keepAlive: true,
          title: i18n.t("protocols.register_privacy_policy_nav_title")
        }
      }
    ]
  },
  //新版本登录页面
  {
    path: "/login-new",
    name: "loginNew",
    component: () => import("@/views/login-new/index.vue"),
    meta: {
      title: '登录',
      keepAlive: true,
    }
  },
  //注册页面首页
  {
    path: "/register",
    name: "register",
    component: () => import("@/views/register/index.vue"),
    meta: {
      showHeader: true,
      keepAlive: true,
      title: i18n.t("register.nav_title")
    }
  },
  //注册页面第二页（设置登录密码）
  {
    path: "/register/password-setting",
    name: "password-setting",
    component: () => import("@/views/register/PasswordSetting.vue"),
    meta: {
      showHeader: true,
      title: i18n.t("register.nav_titile2")
    }
  },
  //忘记登录密码第一页
  {
    path: "/login-password-forget",
    name: "login-password-forget-step-first",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(
        /* webpackChunkName: "about" */ "@/views/login-password-forget/StepFirst.vue"
      ),
    meta: {
      showHeader: true,
      keepAlive: true,
      title: i18n.t("forget_password.nav_title")
    }
  },
  //忘记登录密码第二页
  {
    path: "/login-password-forget/step-second",
    name: "login-password-forget-step-second",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(
        /* webpackChunkName: "about" */ "@/views/login-password-forget/StepSecond.vue"
      ),
    meta: {
      showHeader: true,
      title: i18n.t("forget_password.nav_title")
    }
  }
];
